import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useUnarchiveCustomEvent } from "@src/api/custom-events/unarchive-custom-event";
import { isDialogOpen, setDialog } from "@src/store/slices/global";

interface UnarchiveCustomEventDialogProps {
  eventId: string;
}

export const UnarchiveCustomEventDialog = ({
  eventId,
}: UnarchiveCustomEventDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("unarchiveCustomEvent"));
  const unarchiveCustomEvent = useUnarchiveCustomEvent();

  const handleClose = () => {
    dispatch(setDialog({ dialog: "unarchiveCustomEvent", open: false }));
  };

  const handleUnarchive = () => {
    unarchiveCustomEvent.mutate({
      body: { customEventId: eventId },
      pathParams: undefined,
      queryParams: undefined,
    });
    handleClose();
  };

  return (
    <IgDialog
      showDialog={isOpen}
      handleClose={handleClose}
      title={"Unarchive Event?"}
      handleYesClick={handleUnarchive}
      yesButtonText={"Yes, Unarchive this event"}
      rawContent={
        <IgTypography>
          Unarchiving this event will make it available for tracking when
          setting up a new experiment.
          <br />
          <br />
          Are you sure you want to unarchive it?
        </IgTypography>
      }
    />
  );
};
